export const tablePropertyConstants = {
  TABLE_PROPERTY_LOAD_SUCCESS: 'TABLE_PROPERTY_LOAD_SUCCESS'
};
